"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12.451 1.125a.88.88 0 0 0-.902 0L2.15 6.675c-.866.51-.533 1.945.452 1.945h18.796c.985 0 1.318-1.434.452-1.945l-9.399-5.55Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M2.805 23c-.324 0-.597-.111-.82-.334a1.114 1.114 0 0 1-.333-.82c0-.323.11-.597.333-.82.223-.222.496-.333.82-.333h18.39c.324 0 .597.11.82.333.222.223.334.497.334.82 0 .324-.112.597-.334.82a1.114 1.114 0 0 1-.82.334H2.805Zm13.507-12.656c0-.476.386-.862.862-.862H18.9a.862.862 0 0 1 .215 1.697v6.927c0 .067-.006.134-.018.198a.863.863 0 0 1-.197 1.703h-1.725a.862.862 0 0 1-.197-1.703 1.088 1.088 0 0 1-.018-.199V11.18a.863.863 0 0 1-.647-.835Zm-6.037 0c0-.476.386-.862.863-.862h1.724a.862.862 0 0 1 .216 1.697v6.927c0 .067-.006.134-.018.198a.863.863 0 0 1-.198 1.703h-1.724a.862.862 0 0 1-.198-1.703 1.088 1.088 0 0 1-.018-.199V11.18a.863.863 0 0 1-.647-.835Zm-6.036 0c0-.476.386-.862.862-.862h1.725a.862.862 0 0 1 .215 1.697v6.927c0 .067-.006.134-.018.198a.863.863 0 0 1-.197 1.703H5.1a.862.862 0 0 1-.197-1.703 1.084 1.084 0 0 1-.019-.199V11.18a.863.863 0 0 1-.646-.835Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};